
// Custom
import './customSelects';
import './smoothScrolling-emory';
import './emailSignUpValidation';
import './languageSwitcher';
import './imageGallery';
import './accordionToggle';
import './accordion';
import './listings';
import './carousel-common';
import './cardHoverTransitionEmory';
import './floorplanModal';
import './guides-menu';
import './informationBlock-emory';
import './fileUpload';
import './navigationMinimal-Emory';
import './spaInpageChecker';
import './select2Accessibility';
import './isCMSMode';
import './homepageVideo';
import './line-animations'

import './roomBookings/booking-menu-tabs';
import './roomBookings/availability-checker';
import './roomBookings/calendaraccessibility';
import './roomBookings/room-booking';
import './roomBookings/index';
import './promoBlockVideo';
import { init as initPrimaryNavigationTabs } from './primary-navigation-tabs';

/*import './spaBookings/spa-booking';*/
import './spaBookings/index';

import './moduleInit';

import 'jquery-ui';
import 'jquery-ui-bundle';
import 'jquery-match-height';

import './promoBlockVideo';
import './virtualTour';

import { initSplitVideos } from './splitVideo';
import { storiesInit } from './stories';
import { initialiseAccordionLocoUpdate  } from './accordion';
import { init as initKeyboardInterupts } from './keyboardInterupts';
initKeyboardInterupts();


window.site = 'emory';

window.addEventListener('load', (event) => {
    initSplitVideos();
    initPrimaryNavigationTabs();
    storiesInit();
    initialiseAccordionLocoUpdate();
    // Commented to fix issue with slickslider calculating widths incorrectly when body is position fixed.
    //if (iOS()) {
    //document.body.classList.add('ios');
    // }

    const videoBanner = document.querySelector('.videoBanner');
    const header = document.querySelector('.header');

    if (!videoBanner && header) {
        header.classList.add('header--white');
        header.classList.remove('header--transparent');
        header.querySelector('.header__logo-link').classList.remove('d-none');
    } else if(header){
        header.classList.remove('header--white');
        header.classList.add('header--transparent');

    }

    // Select all split image block instances of naked border and add class to allow for reduced padding when a figcaption is present

    const nakedImageContainer = document.querySelectorAll('.split-image-block__gridImageContainer, .fluidGridContainer__item');

    nakedImageContainer.forEach((imageContainer) => {
        const imageBlockNaked = imageContainer.querySelector('.block-colour--naked')

        if (imageBlockNaked && imageContainer.querySelector('figcaption')) {
            imageBlockNaked.classList.add('reduced-padding__figcaption');
        }
    })

});


function iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

if (navigator.userAgent.includes('CPU iPhone OS 14')) {
    document.body.classList.add('is-safari-14');
}
